// src/main.jsx
import React from 'react'
import ReactDOM from 'react-dom/client'
import { BrowserRouter } from 'react-router-dom'
import { HelmetProvider } from 'react-helmet-async'
import { LangProvider } from './lib/useLang.jsx'
import App from './App.jsx'
import './index.css'

const rootEl = document.getElementById('root')
rootEl.removeAttribute('style')
ReactDOM.createRoot(rootEl).render(
  <HelmetProvider>
    <BrowserRouter>
      <LangProvider>
        <App />
      </LangProvider>
    </BrowserRouter>
  </HelmetProvider>
)
